import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-drag-and-drop',
    host: { 'data-app': 'mgmt' },
    templateUrl: './drag-and-drop.component.html',
    styleUrls: ['./drag-and-drop.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DragAndDropComponent implements OnInit {

  @Input() files: any[];
  @Input() acceptString = 'image/*';
  @Input() isMultiple = false;

  constructor() {
  }

  ngOnInit(): void {
  }

  onFileDropped($event: any) {
    this.prepareFilesList($event);
  }

  fileBrowseHandler(event: any) {
    this.prepareFilesList(event.target.files);
  }

  // fileBrowseHandler(files: any) {
  //   .target.files
  //   this.prepareFilesList(files);
  // }

  prepareFilesList(files: Array<any>) {
    for (const item of files) {
      this.files.push(item);
    }
  }

}
